import { ApolloProvider } from "@apollo/client/react";
import { client } from "./client";

export default function UnauthenticatedClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
